import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import Typography from '@mui/material/Typography';
import { Button } from '@mui/material';
import Grid from '@mui/material/Grid';
import { Link } from 'react-router-dom';

import Page from '../../Components/Page';

import { RootState } from '../../ReduxStore';
import defaultApiErrorHandler from '../../Utils/defaultApiErrorHandler';
import { setUser, UserInfo } from '../../Slices/userSlice';

const EveLogin = () => {
    const location = useLocation();
    const history = useHistory();
    const dispatch = useDispatch();
    const [error, setError] = useState(false);
    const [results, setResults] = useState<UserInfo>(null);
    const user = useSelector((state: RootState) => state.user.loggedIn);

    useEffect(() => {
        const query = new URLSearchParams(location.search);
        const code = query.get('code');
        if (code) {
            const codeExchangeUrl = `${process.env.REACT_APP_API_BASE}/api/auth/eve-callback`;
            axios
                .post(
                    codeExchangeUrl,
                    {
                        code
                    },
                    {
                        withCredentials: true
                    }
                )
                .then(r => r.data)
                .then(data => {
                    setResults(data);
                    dispatch(setUser(data));
                })
                .catch(error => {
                    setError(defaultApiErrorHandler(error));
                });

            // Remove all parameters from URL
            history.replace(`/auth/eve-callback`);
        } else {
            // Send home if we come here directly with no code
            // history.replace(`/`);
        }
    }, []);

    const userInfo = results || user;

    return (
        <Page title="Eve Login">
            <Grid container spacing={2} justifyContent="center" alignItems="center">
                <Grid item xs={12}>
                    {error && <Typography>{error}</Typography>}
                    {userInfo && (
                        <Grid container justifyContent="center" spacing={2}>
                            <Grid item xs={12}>
                                <Typography>Logged in as {userInfo.name}</Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <img
                                    src={`https://images.evetech.net/characters/${userInfo.id}/portrait?size=128`}
                                    alt="Character avatar"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Button component={Link} to="/">
                                    Return home
                                </Button>
                            </Grid>
                        </Grid>
                    )}
                </Grid>
            </Grid>
        </Page>
    );
};

export default EveLogin;
